// // src/components/AddressesSection.js
// import React from 'react';

// const AddressesSection = ({ address, handleInputChange, handleFormSubmit ,isEditable}) => {
//   return (
//     <div className="py-5 lg:pl-14">
//       <form
//         onSubmit={handleFormSubmit}
//         className="grid grid-cols-1 lg:grid-cols-2 gap-4 "
//       >
//         {/* Form Fields */}
//         {[
//           { label: "NAME", name: "firstName", type: "text" },
//           { label: "LAST NAME", name: "lastName", type: "text" },
//           { label: "E-MAIL", name: "email", type: "email" },
//           { label: "PHONE", name: "phone", type: "tel" },
//           // {
//           //   label: "SAVE ADDRESS AS",
//           //   name: "saveAddressAs",
//           //   type: "text",
//           // },
//           {
//             label: "HOUSE/FLAT/BLOCK NUMBER",
//             name: "houseNumber",
//             type: "text",
//           },
//           {
//             label: "AREA / BUILDING NAME",
//             name: "area",
//             type: "text",
//           },
//           { label: "CITY", name: "city", type: "text" },
//           { label: "STATE", name: "state", type: "text" },
//           { label: "PINCODE", name: "pincode", type: "text" },
//           { label: "COUNTRY", name: "country", type: "text" },
//         ].map((field, index) => (
          // <div key={index} className="-my-1">
          //   <input
          //     id={field.name}
          //     name={field.name}
          //     type={field.type}
          //     value={address[field.name]}
          //     onChange={handleInputChange}
          //     required
          //     className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary "
          //     placeholder=" "
          //   />
          //   <label
          //     htmlFor={field.name}
          //     className="relative left-3 px-2 bg-tertiary text-primary1 font-outfit text-sm font-medium pointer-events-none transform -translate-y-4 scale-75 bottom-[80%] z-10 origin-[0] start-4"
          //   >
          //     {field.label}
          //   </label>
          // </div>
//         ))}

//         {/* Buttons in the same row */}
//         <div className="lg:col-span-2 lg:flex justify-center gap-4 -mt-2">
//           <button
//             type="submit"
//             className="w-full lg:w-[50%] py-2 bg-hcolor text-tertiary hover:border-2 hover:text-hcolor hover:bg-tertiary transition"
//           >
//             UPDATE
//           </button>
//           <button
//             type="button"
//             className="w-full lg:w-[50%] py-2 bg-tertiary text-hcolor border-2 hover:bg-hcolor hover:text-tertiary transition"
//           >
//             CANCEL
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AddressesSection;


import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddresses,
  addNewAddress,
  updateExistingAddress,setShippingAddress
} from "../../store/addressSlice";

const AddressesSection = ({}) => {
  const dispatch = useDispatch();
  const { savedAddresses, loading, error } = useSelector((state) => state.address);

  // Updated state with all required fields
  const [address, setAddress] = useState({
    user_id: localStorage.getItem("user_id") || "", // ✅ Get from localStorage
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_id: "",
    addressType: "Home", 
    main_street: "",
    city: "",
    state: "",
    house_number: "",
    postal_code: "",
    country: "",
    landmark: "",
    isDefault: true,
  });
  

  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    dispatch(fetchAddresses());
  }, [dispatch]);

  useEffect(() => {
    if (savedAddresses.length > 0) {
      setAddress(savedAddresses[0]); 
      setEditId(savedAddresses[0]._id);
      setIsEditing(true);
    }
  }, [savedAddresses]);

  const handleInputChange = (e) => {
    const { name, type, value, checked } = e.target;
    setAddress((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      console.error("User ID is missing. Ensure user is logged in.");
      return;
    }
  
    const addressData = { ...address, user_id: userId };
  
    let response;
    if (isEditing) {
      response = await dispatch(updateExistingAddress({ id: editId, updatedAddress: addressData }));
    } else {
      response = await dispatch(addNewAddress(addressData));
    }
  
    if (response?.payload) {
      dispatch(setShippingAddress(response.payload)); // Set newly added address as default
    }
  };
  
  

  return (
    <div className="py-5 lg:pl-14">
      {/* <h2 className="text-xl font-bold mb-4">Default Address</h2> */}
      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">Error: {error}</p>}
      {/* {savedAddresses.length === 0 ? (
        <p>No address found.</p>
      ) : (
        <div className="p-4 border rounded-md mb-4">
          <p>{address.first_name},{address.last_name}, {address.mobile_number},{address.email_id},{address.main_street}, {address.city}, {address.state}, {address.country}</p>
        </div>
      )} */}

<form onSubmit={handleFormSubmit} className="grid grid-cols-1 lg:grid-cols-2 gap-4">
  {[
    { label: "First Name", name: "first_name", type: "text" },
    { label: "Last Name", name: "last_name", type: "text" },
    { label: "Mobile", name: "mobile_number", type: "tel" },
    { label: "Email", name: "email_id", type: "text" },
    { 
      name: "addressType", 
      label: "Save Address As", 
      type: "select", 
      options: ["Home", "Work", "Other"] 
    },
    { label: "House Number", name: "main_street", type: "text" },
    { label: "Landmark", name: "landmark", type: "text" },
    { label: "City", name: "city", type: "text" },
    { label: "State", name: "state", type: "text" },
    { label: "Postal Code", name: "postal_code", type: "text" },
    { label: "Country", name: "country", type: "text" },
  ].map((field, index) => (
    <div key={index} className="-my-1">
      <label
        htmlFor={field.name}
        className="relative left-3 top-3 px-2 bg-tertiary text-primary1 font-outfit text-sm font-medium pointer-events-none transform -translate-y-4 scale-75 bottom-[80%] z-10 origin-[0] start-4"
      >
        {field.label}
      </label>

      {field.type === "select" ? (
        <select
          id={field.name}
          name={field.name}
          value={address[field.name] || ""}
          onChange={handleInputChange}
          className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
        >
          <option value="">Select Address Type</option>
          {field.options.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      ) : (
        <input
          id={field.name}
          name={field.name}
          type={field.type}
          value={address[field.name] || ""}
          onChange={handleInputChange}
          required
          className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
          placeholder=" "
        />
      )}
    </div>
  ))}

  {/* Default Address Checkbox */}
  <div className="lg:col-span-2 flex items-center gap-2">
    <input
      type="checkbox"
      id="isDefault"
      name="isDefault"
      checked={address.isDefault || false}
      onChange={handleInputChange}
      className="w-5 h-5"
    />
    <label htmlFor="isDefault" className="text-sm">Set as Default Address</label>
  </div>

  {/* Submit Button */}
  <div className="lg:col-span-2 flex justify-center gap-4 -mt-2">
    <button
      type="submit"
      className="w-full lg:w-[50%] py-2 bg-blue-600 text-white hover:border-2 hover:text-blue-600 hover:bg-white transition border-blue-600"
    >
      {isEditing ? "Update Address" : "Add Address"}
    </button>
  </div>
</form>

    </div>
  );
};

export default AddressesSection;
